function show_loading_overlay() {
    jQuery('[data-loading-overlay]').addClass('is-open').attr('aria-hidden', false);
    jQuery('body').addClass('loading-overlay-open');
}

function hide_loading_overlay() {
    jQuery('[data-loading-overlay]').removeClass('is-open').attr('aria-hidden', true);
    jQuery('body').removeClass('loading-overlay-open');
}
